export default __webpack_public_path__ + "static/media/Leggings of Mirrored Heaven.0de50b33.jpg";